import React from 'react';
import './App.css';
import { Container } from 'react-bootstrap';
import { BrowserRouter, Route, Routes } from 'react-router';
import Topbar from './components/Topbar';
import AuthCallback from './pages/AuthCallback';
import Dialogs from './components/Dialogs';
import LandingPage from './pages/LandingPage';



function App() {
  return (
    <Container className="main-container">
      <Dialogs />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<><LandingPage /></>} />
          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </BrowserRouter>
    </Container>
  );
}

export default App;
